import React, { useState } from "react";
import { Box, BoxProps, SxProps, Theme } from "@mui/material";

interface FadeInImageProps extends Omit<BoxProps<'img'>, 'component' | 'sx'> {
  src: string;
  alt: string;
  sx?: SxProps<Theme>;
}

export default function FadeInImage({ src, alt, sx, className, ...props }: FadeInImageProps) {
  const [loaded, setLoaded] = useState(false);
  const containerClassName = [className, "fade-in-image-container"].filter(Boolean).join(" ");

  return (
    <Box
      className={containerClassName}
      sx={{
        backgroundColor: loaded ? "transparent" : "#e2e8f0", // modern skeleton color
        overflow: "hidden",
        display: "flex",
        ...sx,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        sx={{
          width: "100%",
          height: "100%",
          display: "block",
          objectFit: "inherit",
          objectPosition: "inherit",
          opacity: loaded ? 1 : 0,
          filter: loaded ? "blur(0px)" : "blur(10px)",
          transition: "opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1), filter 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
        {...props}
      />
    </Box>
  );
}
